import React from 'react';
import PropTypes from 'prop-types';

import videojs from 'video.js';
import 'videojs-flash';
// eslint-disable-next-line
require('!style-loader!css-loader!../css/video-js.css'); // 不让它类名处理

import {isWindows} from '../lib/platform'; // 针对处理windows客户端  据说版权问题不支持mp4
import VideoGuideComponent from '../components/video-guide/video-guide.jsx';


class VideoGuide extends React.Component {
    constructor (props) {
        super(props);
        this.initVideo = this.initVideo.bind(this);
        this.setRef = element => {
            this.videoRef = element;
        };
        this.state = {};
    }
    componentDidMount (){
        this.initVideo();
    }
    componentWillUnmount (){
        this.player.dispose();

    }
    initVideo (){
        if (!this.videoRef) {
            setTimeout(this.initVideo, 30);
            return;
        }
        this.player = videojs(this.videoRef, {
            autoplay: 'autoplay',
            preload: 'auto',
            techOrder: isWindows() ? ['flash', 'html5'] : ['html5', 'flash']
        });
        this.player.addClass('vjs-big-play-centered');
        this.player.addClass('video-js');
    }
    render (){
        return (<VideoGuideComponent
            setRef={this.setRef}
            {...this.props}
        />);
    }
}

VideoGuide.propTypes = {
    onRequestClose: PropTypes.string,
    videoUrl: PropTypes.string
};
export default VideoGuide;
